<template>
  <a
    v-if="value"
    class="text-sky-300 font-light underline"
    target="_blank"
    :href="value"
    @click="onLinkClick"
  >
    <!-- TODO сделать константу -->
    ссылка
  </a>
</template>

<script>
import { metrikaEvents } from '@/services/metrika'

export default {
  name: 'PlatformLink',
  props: {
    value: {
      type: String,
    },
    feed: {
      type: String,
    },
  },
  methods: {
    onLinkClick() {
      metrikaEvents.onPlatformLinkClick(this.feed, this.value)
    },
  },
}
</script>
